document.addEventListener("DOMContentLoaded", function() {
    let parents = document.getElementsByClassName('parent');
    parents = [...parents];

    parents.forEach(parent => {
        parent.addEventListener('click', () => {
            let dataParent = parent.getAttribute('data-parent');
            let children = document.getElementsByClassName('children');
            children = [...children];
            let parentChildren = document.querySelectorAll('[data-children="'+dataParent+'"]');
            parentChildren = [...parentChildren];

            children.forEach(child => {
                child.style.display = 'none';
            });

            parentChildren.forEach(child => {
                child.style.display = 'block';
            });

            parents.forEach(p => {
                p.classList.remove('active');
            });

            parent.classList.add('active');
        });
    });
});